import { useMatch } from "react-router";

import routes from "../routes";

export const useIsProspectListPage = () => {
  const isUnderProspects =
    useMatch(`${routes.prospects.base.pattern}/*`) !== null;
  const isViewPage = useMatch(routes.prospects.view.pattern) !== null;

  return isUnderProspects && !isViewPage;
};
